// Frappe Skins - single stylesheet injector (Desk + website) + Switch Skin dialog.
// Kill switch: append ?no_skin=1 to any URL to disable skinning for the browser
// session (runs before any network call, so it works even when the served CSS
// makes the UI unreadable). ?no_skin=0 re-enables.
(function () {
	function skin_link() {
		return document.querySelector('link[href*="frappe_skins.api.skin_css"]');
	}

	function disable_skin() {
		const link = skin_link();
		if (link) link.disabled = true;
		const tag = document.getElementById("frappe-skins-css");
		if (tag) tag.textContent = "";
	}

	// evaluate the URL param OUTSIDE try/catch: the kill switch must honor the
	// current page load even when sessionStorage access throws
	const params = new URLSearchParams(window.location.search);
	if (params.get("no_skin") === "1") {
		try {
			sessionStorage.setItem("frappe_skins_off", "1");
		} catch (e) {}
		disable_skin();
		return;
	}
	try {
		if (params.get("no_skin") === "0") sessionStorage.removeItem("frappe_skins_off");
		if (sessionStorage.getItem("frappe_skins_off")) {
			disable_skin();
			return;
		}
	} catch (e) {
		// sessionStorage unavailable (rare) - skin normally
	}

	if (!window.frappe || !frappe.call) return;

	function apply_css(css, hash) {
		let tag = document.getElementById("frappe-skins-css");
		if (!tag) {
			tag = document.createElement("style");
			tag.id = "frappe-skins-css";
			document.head.appendChild(tag);
		}
		if (tag.dataset.hash !== hash) {
			tag.textContent = css;
			tag.dataset.hash = hash;
		}
		return tag;
	}

	// the theme itself arrives as a BLOCKING <link> (app/web_include_css) so
	// it is present at first paint; fetch-and-inject only as a fallback for
	// pages that somehow lack the link (keeps old behaviour there)
	if (!skin_link()) {
		frappe.call({
			method: "frappe_skins.api.get_skin_bundle",
			type: "GET",
			callback(r) {
				const m = r && r.message;
				if (!m || !m.css) return;
				apply_css(m.css, m.hash);
			},
		});
	}

	// ---------------------------------------------------------------
	// Switch Skin dialog (Desk only; opened from the Navbar Settings
	// dropdown row installed by patches.v16_1.add_user_skin_field)
	// ---------------------------------------------------------------

	function palette_dots(skin) {
		return ["primary", "secondary", "accent", "neutral"]
			.map((k) => skin[k])
			.filter(Boolean)
			.map(
				(c) =>
					`<span style="display:inline-block;width:14px;height:14px;border-radius:50%;` +
					`border:1px solid var(--border-color,#d1d8dd);margin-right:4px;background:${frappe.utils.escape_html(c)}"></span>`
			)
			.join("");
	}

	function open_switcher() {
		if (!frappe.ui || !frappe.ui.Dialog) return;

		frappe.call({ method: "frappe_skins.api.get_user_skin_options" }).then((r) => {
			const data = r.message || {};
			if (!data.enabled) {
				frappe.msgprint(
					__(
						"Per-user skin choice is not enabled. A System Manager can turn it on in Skin Settings."
					)
				);
				return;
			}

			const original_hash =
				(document.getElementById("frappe-skins-css") || {}).dataset?.hash || "";
			const original_css =
				(document.getElementById("frappe-skins-css") || {}).textContent || "";
			let previewed = false;
			let applied = false;

			const options = [
				{ label: __("Site Default ({0})", [data.default || __("none")]), value: "" },
			].concat(data.skins.map((s) => ({ label: s.name, value: s.name })));

			const body_html = data.skins
				.map(
					(s) =>
						`<div class="skin-option" style="margin-bottom:6px">` +
						`<b>${frappe.utils.escape_html(s.name)}</b>` +
						`${s.name === data.default ? " <span class='text-muted'>(" + __("default") + ")</span>" : ""}` +
						`<div>${palette_dots(s)}</div>` +
						(s.description
							? `<div class="text-muted small">${frappe.utils.escape_html(s.description)}</div>`
							: "") +
						`</div>`
				)
				.join("");

			const d = new frappe.ui.Dialog({
				title: __("Switch Skin"),
				fields: [
					{
						fieldname: "skin",
						fieldtype: "Select",
						label: __("Skin"),
						options: options,
						default: data.current || "",
						change() {
							const value = d.get_value("skin");
							previewed = true;
							if (!value) {
								// site default: restore the css we arrived with only
								// if the default differs from what's applied now
								frappe.call({
									method: "frappe_skins.api.get_skin_bundle",
									type: "GET",
								}).then((res) => {
									const m = res.message || {};
									apply_css(m.css || "", m.hash || "");
								});
								return;
							}
							frappe.call({
								method: "frappe_skins.api.preview_skin",
								args: { skin: value },
							}).then((res) => {
								const m = res.message || {};
								apply_css(m.css || "", m.hash || "");
							});
						},
					},
					{ fieldtype: "HTML", options: body_html },
				],
				primary_action_label: __("Apply"),
				primary_action(values) {
					applied = true;
					frappe.call({
						method: "frappe_skins.api.set_user_skin",
						args: { skin: values.skin || "" },
					}).then(() => {
						d.hide();
						frappe.show_alert({
							message: __("Skin updated"),
							indicator: "green",
						});
						// served bundle now reflects the choice; re-fetch to converge
						frappe.call({
							method: "frappe_skins.api.get_skin_bundle",
							type: "GET",
						}).then((res) => {
							const m = res.message || {};
							apply_css(m.css || "", m.hash || "");
						});
					});
				},
				secondary_action_label: __("Cancel"),
				secondary_action() {
					d.hide();
				},
			});

			d.onhide = () => {
				// cancel/escape after previewing: put the original css back
				if (previewed && !applied) {
					apply_css(original_css, original_hash);
				}
			};

			d.show();
		});
	}

	frappe.provide && frappe.provide("frappe.frappe_skins");
	if (frappe.frappe_skins) {
		frappe.frappe_skins.open_switcher = open_switcher;
	} else {
		frappe.frappe_skins = { open_switcher: open_switcher };
	}
})();
